/**
 * Utility component that builds a HTML snippet for displaying the dynamic layer legend.
 */

const circleHeight = 8;
const circleWidth = 8;
const circleRadius = 4;

const $ = global.$ || global.jQuery || require('jquery');

import { AbstractLegendBuilder } from 'aims-map';

export default class DynamicLayersLegendBuilder extends AbstractLegendBuilder {

  constructor(variablesModel, parentEl) {
    super();

    // Cache the reference(s).
    this._variablesModel = variablesModel;
    this._$parentEl = $(parentEl);

    // Register for events.
    this._variablesModel.on(this._variablesModel.ON_SELECTION_EVENT, this._handleOnChange.bind(this));

  }

  _handleOnChange() {
    this._emitOnChangeEvent();
  }

  /**
   * Concrete implementation of the `buildHtml()` method for static layers.
   */
  buildHtml() {

    let html = '';

    const _selectedVariable = this._variablesModel.getSelectedItem();
    if (_selectedVariable) {

      html += `
        <div class="legend-item">
          <div class="legend-title">${_selectedVariable.title}</div>
          <g class="dynamic-legend-items">
      `;

      // Loop through the symbology to populate the panel.
      _selectedVariable.groupings.forEach(function (_grouping) {

        // A style definition has a Filter and a Symbol.
        const symbol = _grouping.renderings.map.symbol;
        html += `
          <div class="symbol-item">
            <svg width="${circleWidth}" height="${circleHeight}" >
              <circle cx="${circleWidth / 2}" cy="${circleHeight / 2}" r="${circleRadius}" 
                    style="fill: ${symbol.fill.color}"></circle>
            </svg>
            <text>${_grouping.renderings.map.title}</text>
          </div>
        `;

      }, this);

      html += '</g></div>';

    }

    return html;

  }

}



// WEBPACK FOOTER //
// ./src/app/map/dynamic-layers-legend-builder.js